import { BaseNode, Component, __private } from 'cc';
import { AbstractConstructor } from '../Utils/UtilityType';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Component {
        on(...args: Parameters<BaseNode['on']>): ReturnType<BaseNode['on']>;
        once(...args: Parameters<BaseNode['once']>): ReturnType<BaseNode['once']>;
        emit(...args: Parameters<BaseNode['emit']>): ReturnType<BaseNode['emit']>;
        off(...args: Parameters<BaseNode['off']>): ReturnType<BaseNode['off']>;
        targetOff(...args: Parameters<BaseNode['targetOff']>): ReturnType<BaseNode['targetOff']>;
        dispatchEvent(...args: Parameters<BaseNode['dispatchEvent']>): ReturnType<BaseNode['dispatchEvent']>;
        hasEventListener(...args: Parameters<BaseNode['hasEventListener']>): ReturnType<BaseNode['hasEventListener']>;

        getComponent<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T | null;
        getComponents<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T[];
        getComponentInChildren<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T | null;
        getComponentsInChildren<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T[];
        getComponentInParent<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T | null;
        getComponentsInParent<T extends Component>(classConstructor: __private._types_globals__Constructor<T> | AbstractConstructor<T>): T[];
    }
}

Component.prototype.on = function on(this: Component, ...args: Parameters<BaseNode['on']>): ReturnType<BaseNode['on']> {
    return this.node.on(...args);
};
Component.prototype.once = function once(this: Component, ...args: Parameters<BaseNode['once']>): ReturnType<BaseNode['once']> {
    return this.node.once(...args);
};
Component.prototype.emit = function emit(this: Component, ...args: Parameters<BaseNode['emit']>): ReturnType<BaseNode['emit']> {
    return this.node.emit(...args);
};
Component.prototype.off = function off(this: Component, ...args: Parameters<BaseNode['off']>): ReturnType<BaseNode['off']> {
    return this.node?.off(...args);
};
Component.prototype.targetOff = function targetOff(this: Component, ...args: Parameters<BaseNode['targetOff']>): ReturnType<BaseNode['targetOff']> {
    return this.node?.targetOff(...args);
};
Component.prototype.dispatchEvent = function dispatchEvent(
    this: Component,
    ...args: Parameters<BaseNode['dispatchEvent']>
): ReturnType<BaseNode['dispatchEvent']> {
    return this.node.dispatchEvent(...args);
};
Component.prototype.hasEventListener = function hasEventListener(
    this: Component,
    ...args: Parameters<BaseNode['hasEventListener']>
): ReturnType<BaseNode['hasEventListener']> {
    return this.node.hasEventListener(...args);
};
Component.prototype.getComponentInParent = function getComponentInParent<T extends Component>(
    this: Component,
    classConstructor: __private._types_globals__Constructor<T>,
): T | null {
    return this.node.getComponentInParent(classConstructor);
};
Component.prototype.getComponentsInParent = function getComponentsInParent<T extends Component>(
    this: Component,
    classConstructor: __private._types_globals__Constructor<T>,
): T[] {
    return this.node.getComponentsInParent(classConstructor);
};
